import { useEffect } from 'react';
import { Button } from 'primereact/button';
import makeForm from '../../../components/Form';
import { useForm } from '../../../components/Form/hooks';
import Yup from '../../../utils/yup';
import useLinhaTempoStore from '../store';
import { LinhaTempoFiltros, LinhaTempoViewMode } from '../types';
import useLocalStore from '../../../hooks/use-local-store';
import { empty } from '../../../utils/constants';

const VIEW_MODE_OPTIONS: {
  label: string;
  value: LinhaTempoViewMode;
}[] = [{ label: 'Semana atual', value: 'currentWeek' }];

const validationSchema = Yup.object().shape({
  viewMode: Yup.string().required(),
});

const defaultValues = useLinhaTempoStore.getInitialState().filtros;

const Form = makeForm<LinhaTempoFiltros>();

const DROPDOWN_PROPS = {
  withErrorMessage: false,
  containerClassName: 'field',
};

const Filtros = () => {
  const formObject = useForm<LinhaTempoFiltros>({
    validationSchema,
    defaultValues,
  });
  const { setValue } = formObject.form;
  const talhoes =
    useLocalStore('currentPropriedade').value?.glebas || empty.array;

  const setFiltros = useLinhaTempoStore((state) => state.setFiltros);
  const storeFiltros = useLinhaTempoStore((state) => state.filtros);

  useEffect(() => {
    const keys = Object.keys(storeFiltros) as (keyof LinhaTempoFiltros)[];

    keys.forEach((key) => setValue(key, storeFiltros[key]));
  }, [setValue, storeFiltros]);

  return (
    <Form
      formObject={formObject}
      onSubmit={setFiltros}
      className="bottom-sheet-filtros"
    >
      <Form.Dropdown
        name="viewMode"
        options={VIEW_MODE_OPTIONS}
        dataKey="value"
        optionLabel="label"
        {...DROPDOWN_PROPS}
      />

      <Form.Dropdown
        name="talhao"
        options={talhoes}
        dataKey="id"
        optionLabel="descricao"
        placeholder="Talhão"
        disabled
        {...DROPDOWN_PROPS}
      />

      <Form.Dropdown
        name="cultura"
        options={empty.array}
        placeholder="Cultura"
        disabled
        {...DROPDOWN_PROPS}
      />

      <Form.Dropdown
        name="registro"
        options={empty.array}
        placeholder="Registro"
        disabled
        {...DROPDOWN_PROPS}
      />

      <Form.Dropdown
        name="usuario"
        options={empty.array}
        placeholder="Usuário"
        disabled
        {...DROPDOWN_PROPS}
      />

      <Button label="Pesquisar" type="submit" severity="info" />

      <Button
        label="Limpar"
        severity="danger"
        onClick={() => formObject.form.reset()}
      />
    </Form>
  );
};

export default Filtros;
